<template>
  <div class="step1-upload container my-4">
    <div
      class="upload-box p-4 border rounded text-center"
      @dragover.prevent
      @drop.prevent="handleDrop"
      @click="triggerFileInput"
      style="cursor: pointer;"
    >
      <img v-if="previewUrl" :src="previewUrl" class="img-fluid mx-auto d-block mb-3" />
      <div v-else>
        <img src="@/assets/image/ai/preview_img.png" alt="upload" class="img-fluid mx-auto mb-4" />
        <p>拖移檔案到框內，或點選按鈕開啟資料夾上傳圖片</p>
        <p class="mb-3">檔案需小於10Mb,  圖片長寬像素必須小於10000px</p>
        <button class="btn text-blue-main border-blue-main font-weight-bold py-2 px-4" type="button">上傳圖片</button>
      </div>
      <input
        type="file"
        ref="fileInput"
        accept="image/*"
        class="d-none"
        @change="handleFileChange"
      />
    </div>

    <div class="actions mt-4 text-center" v-if="file">
      <button @click="reset" class="btn text-blue-main border-blue-main font-weight-bold mr-2 py-2 px-4">重新上傳圖片</button>
      <button @click="nextStep" class="btn btn-primary bg-blue-main font-weight-bold py-2 px-4">確認並送出</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: null,
      previewUrl: ''
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click()
    },

    handleFileChange(e) {
      const selected = e.target.files[0]
      if (!selected) return
      this.validateImage(selected, e.target)
    },
    handleDrop(e) {
      const dropped = e.dataTransfer.files[0]
      if (dropped) {
        this.validateImage(dropped)
      }
    },
    validateImage(imgFile, inputEl = null) {
      const isImage = imgFile.type.startsWith('image/')
      if (!isImage) {
        alert('請選擇圖片檔案（例如 .jpg、.png）')
        if (inputEl) inputEl.value = ''
        this.reset()
        return
      }

      const maxSize = 10 * 1024 * 1024 // 10MB
      if (imgFile.size > maxSize) {
        alert('檔案大小不能超過 10MB')
        if (inputEl) inputEl.value = ''
        this.reset()
        return
      }

      const reader = new FileReader()
      reader.onload = (event) => {
        const img = new Image()
        img.onload = () => {
          if (img.width > 10000 || img.height > 10000) {
            alert('圖片尺寸不能超過 10000 像素')
            if (inputEl) inputEl.value = ''
            this.reset()
            return
          }

          this.file = imgFile
          this.previewUrl = URL.createObjectURL(imgFile)
        }
        img.src = event.target.result
      }
      reader.readAsDataURL(imgFile)
    },
    nextStep() {
      if (this.file) {
        this.$emit('next', this.file)
      }
    },
    reset() {
      this.file = null
      this.previewUrl = ''
    }
  }
}
</script>
<style scoped>
.step1-upload {
  text-align: center;
}
.steps {
  display: flex;
  justify-content: space-around;
  margin-bottom: 1rem;
}
.steps span {
  padding: 0.5rem 1rem;
  border-radius: 999px;
  background: #ccc;
  color: white;
}
.steps .active {
  background: #915b43;
}

.upload-box {
  border: 2px dashed #ccc;
}
.upload-placeholder {
  color: #999;
}
.upload-btn {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  border: 2px solid #996E5D;
  color: #996E5D;
  background: transparent;
  border-radius: 4px;
}
.preview_img {
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
}
.hidden {
  display: none;
}
.actions {
  margin-top: 1.5rem;
}
.submit_btn {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  border: 2px solid #915b43;
  color: #ffffff;
  background: #915b43;
  border-radius: 4px;
}
</style>
